export * from './caption.component';

